import React from 'react';
import { useEligibleFeaturePopup } from '../../hooks/queries/useFeaturePopups';
import { FeatureGraphicPopupModal } from './FeatureGraphicPopupModal';

export const FeatureGraphicPopupContainer: React.FC = () => {
  const { popup, dismiss, snooze, triggerAction } = useEligibleFeaturePopup();

  if (!popup) return null;

  return (
    <FeatureGraphicPopupModal
      popup={popup}
      isOpen={!!popup}
      onDismiss={dismiss}
      onSnooze={snooze}
      onAction={triggerAction}
    />
  );
};
